function _s(o, i, p, l) {
    void 0 === i && (i = 400),
        void 0 === l && (l = !1),
        (o.style.overflow = "hidden"),
        l && (o.style.display = "block");
    var n,
        t = window.getComputedStyle(o),
        s = parseFloat(t.getPropertyValue("height")),
        a = parseFloat(t.getPropertyValue("padding-top")),
        r = parseFloat(t.getPropertyValue("padding-bottom")),
        y = parseFloat(t.getPropertyValue("margin-top")),
        d = parseFloat(t.getPropertyValue("margin-bottom")),
        g = s / i,
        m = a / i,
        h = r / i,
        u = y / i,
        x = d / i;
    window.requestAnimationFrame(function t(e) {
        void 0 === n && (n = e);
        e -= n;
        l
            ? ((o.style.height = g * e + "px"),
                (o.style.paddingTop = m * e + "px"),
                (o.style.paddingBottom = h * e + "px"),
                (o.style.marginTop = u * e + "px"),
                (o.style.marginBottom = x * e + "px"))
            : ((o.style.height = s - g * e + "px"),
                (o.style.paddingTop = a - m * e + "px"),
                (o.style.paddingBottom = r - h * e + "px"),
                (o.style.marginTop = y - u * e + "px"),
                (o.style.marginBottom = d - x * e + "px")),
            i <= e
                ? ((o.style.height = ""),
                    (o.style.paddingTop = ""),
                    (o.style.paddingBottom = ""),
                    (o.style.marginTop = ""),
                    (o.style.marginBottom = ""),
                    (o.style.overflow = ""),
                    l || (o.style.display = "none"),
                    "function" == typeof p && p())
                : window.requestAnimationFrame(t);
    });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
    0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
    (HTMLElement.prototype.slideUp = function (t, e) {
        _s(this, t, e);
    }),
    (HTMLElement.prototype.slideDown = function (t, e) {
        _s(this, t, e, !0);
    });

// Listen for the "dialog:cart:updated" event on the document (Ask Dialog app)
document.addEventListener("dialog:cart:updated", function (event) {
    const cartDrawer = document.querySelector("apt-cart-drawer");
    if (!cartDrawer) return;

    // Récupérer le nombre d'items actuel pour comparer
    const currentCountEl = document.querySelector('[data-cart-count]');
    const currentCount = currentCountEl ? parseInt(currentCountEl.textContent) || 0 : 0;

    // Fonction pour vérifier si le panier a été mis à jour
    const checkCartUpdated = (attempts = 0) => {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                // Si le panier a changé ou après 10 tentatives, ouvrir le drawer
                if (cart.item_count !== currentCount || attempts >= 10) {
                    // Mettre à jour le compteur
                    document.querySelectorAll('[data-cart-count]').forEach(el => {
                        el.textContent = cart.item_count;
                    });

                    // Refresh le contenu du drawer
                    if (typeof cartDrawer.refresh === 'function') {
                        cartDrawer.refresh();
                    }

                    // Ouvrir le drawer après le refresh
                    setTimeout(function () {
                        if (typeof cartDrawer.open === 'function') {
                            cartDrawer.open();
                        } else {
                            cartDrawer.classList.add('active');
                        }
                    }, 100);
                } else if (attempts < 10) {
                    // Réessayer après 200ms
                    setTimeout(() => checkCartUpdated(attempts + 1), 200);
                }
            });
    };

    // Commencer à vérifier après un court délai
    setTimeout(() => checkCartUpdated(0), 100);
});



